import type { ApiError } from "@japa-reader/contracts";
import { apiBaseUrl, cloudIsConfigured, getAccessToken } from "../auth";

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!cloudIsConfigured()) {
    throw new Error("Conecte este ambiente à infraestrutura AWS para usar esta função.");
  }
  const accessToken = await getAccessToken();
  if (!accessToken) throw new Error("Sua sessão expirou. Entre novamente com o Google.");

  const response = await fetch(`${apiBaseUrl()}${path.startsWith("/") ? path : `/${path}`}`, {
    ...init,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      ...(init.body && !(init.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json() as T | ApiError
    : await response.text();
  if (!response.ok) {
    throw new Error(apiErrorMessage(payload, response.status));
  }
  return payload as T;
}

export function apiErrorMessage(payload: unknown, status: number) {
  const fallback = `Falha na API (${status}).`;
  if (typeof payload === "string") return payload.trim() || fallback;
  if (!payload || typeof payload !== "object") return fallback;

  const value = payload as Record<string, unknown>;
  return nestedMessage(value.error) || nestedMessage(value.message) || fallback;
}

function nestedMessage(value: unknown): string {
  if (typeof value === "string") return value.trim();
  if (!value || typeof value !== "object") return "";
  const nested = value as Record<string, unknown>;
  return nestedMessage(nested.message) || nestedMessage(nested.error);
}
